/* eslint-disable react/no-children-prop */
import React, { Component } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { reduxForm } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ModalMessage from '../../../shared/components/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { changeThemeToDark, changeThemeToLight } from '../../../redux/actions/themeActions';


class ProfileSettings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      typeOfDocument: '',
      documentNumber: '',
      id_user: '',
      username: '',
      names: '',
      firstLastName: '',
      secondLastName: '',
      estado: '',
      address: '',
      email: '',
      gender: '',
      cellphone: '',
      telephone1: '',
      telephone2: '',
      id_perfil: '',
      birthday: new Date(),
      id_cargo: '',
      id_usuario: '',
      intentos: '',
      password: '',
      races: [],
      ethnicity: '',
      ethnicities: [],
      country: '',
      department: '',
      city: '',
      id_city: '',
      regime: '',
      regimes: [],
      exist: false,
      update: false,
      errors: {},
      error: false,
      openAlert: false,
      modalAlert: { message: '', color: '', title: '' },
      openMap: false,
      departments: [],
      cities: [],
      mode: "No",
      file: null,
      firmUser: null
    }
  }

  componentDidMount() {
    console.log(this.props);
    this.loadUser();
    this.loadDepartment().then((departments) => {
      this.setState({ departments: departments }, () => {
        //console.log(departments);          
      })
    });
    this.loadCities();

  }

  loadUser = () => {

    //console.log(user.usuario);
    const user = JSON.parse(sessionStorage.getItem('usuario'));

    const data = { num_documento: "", nombres: "", apellido1: "", apellido2: "", usuario: user.usuario }
    console.log(data);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log("USUARIO",data);
        if (data.existe) {

          let firmUserUrl = null;

          if(data.contenido[0].firma != null)
          {
            firmUserUrl = process.env.REACT_APP_PUBLIC_URL + 'usuario/' + data.contenido[0].id_usuario + '/' + data.contenido[0].firma + '/' + sessionStorage.getItem('token');
          }

          this.setState({
            documentNumber: data.contenido[0].num_documento,
            id_user: data.contenido[0].id_usuario,
            password: data.contenido[0].password,
            names: data.contenido[0].nombres,
            firstLastName: data.contenido[0].apellido1,
            secondLastName: data.contenido[0].apellido2,
            gender: data.contenido[0].sexo,
            email: data.contenido[0].correo,
            cellphone: data.contenido[0].celular,
            telephone1: data.contenido[0].tel_fijo,
            telephone2: data.contenido[0].telefono2,
            birthday: data.contenido[0].fec_nacimiento,
            typeOfDocument: data.contenido[0].tip_documento,
            id_usuario: data.contenido[0].id_usuario,
            id_cargo: data.contenido[0].id_cargo,
            id_perfil: data.contenido[0].id_perfil,
            department: data.contenido[0].direccion === null ? '' : data.contenido[0].direccion.id_departamento,
            city: data.contenido[0].direccion === null ? '' : data.contenido[0].direccion.ciudad,
            id_city: data.contenido[0].direccion === null ? '' : data.contenido[0].direccion.id_ciudad,
            country: data.contenido[0].direccion === null ? '' : data.contenido[0].direccion.id_pais,
            address: data.contenido[0].direccion === null ? '' : data.contenido[0].direccion.direccion,
            firmUser: firmUserUrl
          });
        }
      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDepartment = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })

  }

  loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  }

  loadcity = (id) => {
    let data = { id_ciudad: id };
    //console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => {
          console.error('Error:', error);
          resolve(error);
        });
    })
  }

  validateData = () => {

    var errors = this.state.errors;
    var error = false;

    if (this.state.typeOfDocument === "") {
      errors.typeOfDocument = "Seleccione un tipo de documento";
      error = true;
    } else {
      errors.typeOfDocument = "";
    }

    if (this.state.documentNumber === "") {
      errors.documentNumber = "Ingrese un número de documento";
      error = true;
    } else {
      errors.documentNumber = "";
    }

    if (this.state.names === "") {
      errors.names = "Ingrese al menos un nombre";
      error = true;
    } else {
      errors.names = "";
    }

    if (this.state.firstLastName === "") {
      errors.firstLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.firstLastName = "";
    }

    if (this.state.secondLastName === "") {
      errors.secondLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.secondLastName = "";
    }

    if (this.state.gender === "") {
      errors.gender = "Seleccione un genero";
      error = true;
    } else {
      errors.gender = "";
    }

    if (moment(this.state.birthday).format("YYYY/MM/DD") === moment(new Date()).format("YYYY/MM/DD")) {
      errors.birthday = "Seleccione una fecha";
      error = true;
    } else {
      errors.birthday = "";
    }

    if (this.state.country === "") {
      errors.country = "Seleccione un país";
      error = true;
    } else {
      errors.country = "";
    }

    if (this.state.department === "") {
      errors.department = "Seleccione un departamento";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.city === "") {
      errors.city = "Seleccione una ciudad";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.address === "") {
      errors.address = "Ingrese una dirección";
      error = true;
    } else {
      errors.address = "";
    }

    if (this.state.telephone1 === "") {
      errors.telephone1 = "Ingrese una telefono";
      error = true;
    } else {
      errors.telephone1 = "";
    }

    if (this.state.cellphone === "") {
      errors.cellphone = "Ingrese un celular";
      error = true;
    } else {
      errors.cellphone = "";
    }


    if (this.state.email === "") {
      errors.email = "Ingrese un email";
      error = true;
    } else {
      errors.email = "";
    }

    if (this.state.civilStatus === "") {
      errors.civilStatus = "Seleccione un estado civil";
      error = true;
    } else {
      errors.civilStatus = "";
    }

    if (this.state.race === "") {
      errors.race = "Seleccione un raza";
      error = true;
    } else {
      errors.race = "";
    }

    if (this.state.ethnicity === "") {
      errors.ethnicity = "Seleccione etnia";
      error = true;
    } else {
      errors.ethnicity = "";
    }

    if (this.state.bloodType === "") {
      errors.bloodType = "Seleccione etnia";
      error = true;
    } else {
      errors.bloodType = "";
    }

    //console.log(errors);
    this.setState({ errors: errors, error: error });
  }



  updateUser = () => {

    this.validateData();
    if (this.state.error) {

      let data = {
        ape1: this.state.firstLastName,
        ape2: this.state.secondLastName,
        nombres: this.state.names,
        sexo: this.state.gender,
        fec_nacimiento: this.state.birthday,
        direccion: {
          id_pais: '00038',
          id_dpto: this.state.departments.filter((department) => department.depcod === this.state.department)[0].depcod,
          id_ciudad: this.state.id_city,
          direccion: this.state.address
        },
        tel_fijo: this.state.telephone1,
        telefono2: this.state.telephone2,
        celular: this.state.cellphone,
        correo: this.state.email,
        id_cargo: this.state.id_cargo,
        id_usuario: this.state.id_usuario,
        id_perfil: this.state.id_perfil,

      };

      console.log(data);

      fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/update', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then(data => {
          console.log(data);
          this.setState({
            openAlert: true,
            modalAlert: {
              message: "Usuario actualizado con exito",
              color: 'success',
              title: "Exitoso!"
            }
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  handlerDocumentNumber = (number) => {
    this.setState({ documentNumber: number }, () => {
    });
  }

  handlerPassword = (password) => {
    this.setState({ password: password }, () => {
    });
  }

  handlerTypeOfDocument = (type) => {
    this.setState({ typeOfDocument: type });
  }

  handlerNames = (names) => {
    this.setState({ names: names });
  }

  handlerFirstLastName = (name) => {
    this.setState({ firstLastName: name });
  }


  handlerSecondLastName = (name) => {
    this.setState({ secondLastName: name });
  }

  handlerGender = (gender) => {
    this.setState({ gender: gender });
  }

  handlerBirthDate = (birthday) => {
    this.setState({ birthday: birthday });
  };

  handlerCivilStatus = (status) => {
    this.setState({ civilStatus: status });
  }

  handlerRace = (race) => {
    this.setState({ race: race });
  }

  handlerEthnicity = (ethnicity) => {
    this.setState({ ethnicity: ethnicity })
  }

  handlerCountry = (country) => {
    this.setState({ country: country });
  }

  handlerDepartment = (department) => {
    this.setState({ department: department, city: [] }, () => {
      this.loadCities(department).then((cities) => {
        console.log(cities);
        this.setState({ cities: cities })
      });
    });
  }

  handleCity = (e) => {
    console.log(e);
    this.setState({ city: e });
  }

  handlerCity = (city) => {
    this.setState({ city: city });
  }

  handlerAddress = (address) => {
    this.setState({ address: address });
  }

  handlerTelephone1 = (telephone) => {
    this.setState({ telephone1: telephone })
  };

  handlerTelephone2 = (telephone) => {
    this.setState({ telephone2: telephone })
  };

  handlerCellphone = (cellphone) => {
    this.setState({ cellphone: cellphone })
  };

  handlerEmail = (email) => {
    this.setState({ email: email });
  };

  handlerRegime = (regime) => {
    this.setState({ regime: regime })
  }

  handlerBloodType = (bloodType) => {
    this.setState({ bloodType: bloodType });
  }

  handlerModeDark = (mode) => {
    const { dispatch } = this.props;
    if (mode === "Si") {
      dispatch(changeThemeToDark());
      this.setState({ mode: "Si" });
    }
    else {
      dispatch(changeThemeToLight());
      this.setState({ mode: "No" });
    }

  }

  updateSign = () => {

    if (this.state.file !== null) {

      const user = JSON.parse(sessionStorage.getItem('usuario'));
      ///usuario/update-firma
      var dataFile = new FormData();
      dataFile.append("firma", this.state.file);
      dataFile.append("id_usuario", user.id_usuario);

      fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/update-firma', {
        method: 'PUT',
        headers: {
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: dataFile
      })
        .then(response => {
          if (response.status !== 500 || response.status !== 404) {
            return response.text();
          }

        })
        .then(data => {
          console.log(data);
          alert("Firma Actualizada Correctamente");

        });

    } else {
      alert("no has subido ningun archivo");
    }

  }

  render() {

    return (
      <form className="material-form" >
        <div style={{ flex: 1, flexDirection: 'row' }}>
          <TextField
            required
            id="first-name-standard-required"
            label="Nombres"
            className="material-form__field"
            style={{ width: 300 }}
            type="text"
            value={this.state.names}
            onChange={(e) => { this.handlerNames(e.target.value); }}
            error={this.state.errors.hasOwnProperty("names") ? this.state.errors.names !== "" : false}
            helperText={this.state.errors.names}
          />
          <TextField
            required
            id="first-last-name-standard-required"
            label="Primer apellido"
            type="text"
            className="material-form__field"
            style={{ width: 300, marginLeft: 100 }}
            value={this.state.firstLastName}
            onChange={(e) => {
              this.handlerFirstLastName(e.target.value);
            }}
            error={this.state.errors.hasOwnProperty("firstLastName") ? this.state.errors.firstLastName !== "" : false}
            helperText={this.state.errors.firstLastName}
          />
        </div>
        <div style={{ flex: 1, flexDirection: 'row' }}>
          <TextField
            required
            id="second-last-name-standard-required"
            label="Segundo apellido"
            type="text"
            className="material-form__field"
            style={{ width: 300 }}
            value={this.state.secondLastName}
            onChange={(e) => {
              this.handlerSecondLastName(e.target.value);
            }}
            error={this.state.errors.hasOwnProperty("secondLastName") ? this.state.errors.secondLastName !== "" : false}
            helperText={this.state.errors.secondLastName}
          />


          <MuiPickersUtilsProvider utils={MomentUtils} >
            <DatePicker
              disableFuture
              label="Fecha de Nacimiento"
              className="material-form__field"
              views={["year", "month", "date"]}
              style={{ width: 300, marginLeft: 100 }}
              value={this.state.birthday}
              onChange={(date) => {
                this.handlerBirthDate(new Date(date));
              }}
              animateYearScrolling
              format="yyyy/MM/D"
              error={this.state.errors.hasOwnProperty("birthday") ? this.state.errors.birthday !== "" : false}
              helperText={this.state.errors.birthday}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div style={{ flex: 1, flexDirection: 'row' }}>
          <TextField
            required
            id="email-standard-required"
            label="Correo electrónico"
            type="email"
            className="material-form__field"
            style={{ width: 300 }}
            value={this.state.email}
            onChange={(e) => {
              this.handlerEmail(e.target.value);
            }}
            error={this.state.errors.hasOwnProperty("email") ? this.state.errors.email !== "" : false}
            helperText={this.state.errors.email}
          />

          <TextField
            id="second-telephone-standard-required"
            label="Teléfono"
            className="material-form__field"
            type="text"
            style={{ width: 300, marginLeft: 100 }}
            value={this.state.telephone1}
            onChange={(e) => {
              this.handlerTelephone1(e.target.value);
            }}
          />
        </div>
        <div style={{ flex: 1, flexDirection: 'row' }}>
          <TextField
            id="second-telephone-standard-required"
            label="Celular"
            type="text"
            className="material-form__field"
            style={{ width: 300 }}
            value={this.state.cellphone}
            onChange={(e) => {
              this.handlerTelephone2(e.target.value);
            }}
          />
          <TextField
            label="País"
            id="id-simplepais-select"
            className="material-form__field"
            style={{ width: 300, marginLeft: 100 }}
            select
            value={this.state.country}
            onChange={(event) => {
              this.handlerCountry(event.target.value);
            }}
            error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}

          >
            <MenuItem className="material-form__option" value={"00038"}>Colombia</MenuItem>
            <FormHelperText>{this.state.errors.country}</FormHelperText>
          </TextField>

        </div>
        <div style={{ flex: 1, flexDirection: 'row' }} >
          <TextField
            className="material-form__field"
            label="Departamento"
            id="id-simpledep-select"
            style={{ width: 300 }}
            select
            value={this.state.department}
            onChange={(event) => {
              this.handlerDepartment(event.target.value);
            }}
            error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
          >
            {this.state.departments.map((department) => {
              return <MenuItem className="material-form__option" key={department.id} value={department.depcod}>{department.depnom}</MenuItem>
            })}
            <FormHelperText>{this.state.errors.department}</FormHelperText>
          </TextField>

          <TextField
            className="material-form__field"
            label="Ciudad"
            id="id-simplecity-select"
            style={{ width: 300, marginLeft: 100 }}
            select
            value={this.state.city}
            onChange={(event) => {
              this.handlerCity(event.target.value);
            }}
            error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
          >
            <MenuItem key={0} value={this.state.city}>{this.state.city}</MenuItem>
            {this.state.cities.map((city) => {
              return <MenuItem className="material-form__option" key={city.id} value={city.ciucod}>{city.ciunom}</MenuItem>
            })}
            <FormHelperText>{this.state.errors.city}</FormHelperText>
          </TextField>
        </div>
        <div>
          <TextField
            required
            id="address-standard-required"
            label="Dirección"
            type="text"
            className="material-form__field"
            style={{ width: 300 }}
            value={this.state.address}
            onChange={(e) => {
              this.handlerAddress(e.target.value);
            }}
            error={this.state.errors.hasOwnProperty("address") ? this.state.errors.address !== "" : false}
            helperText={this.state.errors.address}
          />
          <FormControl component="fieldset" style={{ marginLeft: 100, marginTop: 10 }} >
            <h5 className="bold-text">Modo Oscuro</h5>
            <RadioGroup
              defaultValue='No'
              aria-label="modedark"
              name="mood-radios"
              className="material-form__field"
              style={{ flexDirection: 'row' }}
              value={this.state.mode}
              onChange={(event) => {
                console.log(event.target.value);
                this.handlerModeDark(event.target.value);
              }}
            >
              <FormControlLabel className="radio-btn" value='Si' control={<Radio style={{ color: '#3f51b5' }} />} label="Sí" />
              <FormControlLabel className="radio-btn" value='No' control={<Radio style={{ color: '#3f51b5' }} />} label="No" />
            </RadioGroup>
          </FormControl>

        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button
            color="primary"
            onClick={() => {
              this.updateUser();

            }}>
            Actualizar
          </Button>
        </ButtonToolbar>

        <div>
          {
            this.state.firmUser != null ? <img style={{ width : '30%'}} src={this.state.firmUser} className="img-fluid" alt="Responsive image" />
              : null
          }

        </div>


        <div className="form__form-group" style={{ marginTop: 10 }}>
          <span className="form__form-group-label">
            Agregar Firma, ¿No tiene firma digital? <a target='_blank' href='https://createmysignature.com/'>click aqui para crear tu firma digital</a>
          </span>
          <div className="form__form-group-field">
            <input
              style={{ width: '80%' }}
              type="file"
              accept='image/*'
              onChange={(e) => {
                console.log(e.target.files[0]);
                this.setState({ file: e.target.files[0] });
              }}
            />
          </div>
          <span className="form__form-group-label" style={{ color: 'red' }}>
            {this.state.errors.hasOwnProperty("file") ? this.state.errors.file : ""}
          </span>
        </div>

        <Button
          color="primary"
          size="sm"
          onClick={() => {
            this.updateSign();
          }}>
          Guardar Firma
        </Button>


        {this.state.openAlert ?
          <ModalMessage
            color={this.state.modalAlert.color}
            title={this.state.modalAlert.title}
            message={this.state.modalAlert.message}
            modal={this.state.openAlert}
            toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
            onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}
          /> : null}
      </form>
    );
  }
}

export default reduxForm({
  form: 'profile_settings_form', // a unique identifier for this form
})(ProfileSettings);
